export default __webpack_public_path__ + "static/media/photo--sm--group-full.8befda98.jpg";